module.exports = __webpack_public_path__ + "img/header-weddingRingsSoleil.8ff0861.jpg";